// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Arquivo: animations.css - Adicione este arquivo ao projeto */

/* Animações de entrada */
@keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translateX(-30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes fadeInRight {
    from {
      opacity: 0;
      transform: translateX(30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  /* Animações de loading */
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  @keyframes bounce {
    0%, 100% {
      transform: translateY(-25%);
      animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
    }
    50% {
      transform: translateY(0);
      animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
  }
  
  /* Animações de hover */
  @keyframes shake {
    0%, 100% {
      transform: translateX(0);
    }
    10%, 30%, 50%, 70%, 90% {
      transform: translateX(-2px);
    }
    20%, 40%, 60%, 80% {
      transform: translateX(2px);
    }
  }
  
  @keyframes heartbeat {
    0% {
      transform: scale(1);
    }
    14% {
      transform: scale(1.1);
    }
    28% {
      transform: scale(1);
    }
    42% {
      transform: scale(1.1);
    }
    70% {
      transform: scale(1);
    }
  }
  
  @keyframes glow {
    0%, 100% {
      box-shadow: 0 0 5px rgba(79, 70, 229, 0.5);
    }
    50% {
      box-shadow: 0 0 20px rgba(79, 70, 229, 0.8);
    }
  }
  
  /* Classes utilitárias para animações */
  .animate-fade-in-up {
    animation: fadeInUp 0.6s ease-out;
  }
  
  .animate-fade-in-down {
    animation: fadeInDown 0.6s ease-out;
  }
  
  .animate-fade-in-left {
    animation: fadeInLeft 0.6s ease-out;
  }
  
  .animate-fade-in-right {
    animation: fadeInRight 0.6s ease-out;
  }
  
  .animate-scale-in {
    animation: scaleIn 0.3s ease-out;
  }
  
  .animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
  
  .animate-spin {
    animation: spin 1s linear infinite;
  }
  
  .animate-bounce {
    animation: bounce 1s infinite;
  }
  
  .animate-shake {
    animation: shake 0.5s ease-in-out;
  }
  
  .animate-heartbeat {
    animation: heartbeat 2s ease-in-out infinite;
  }
  
  .animate-glow {
    animation: glow 2s ease-in-out infinite alternate;
  }
  
  /* Delays para animações sequenciais */
  .delay-100 {
    animation-delay: 100ms;
  }
  
  .delay-200 {
    animation-delay: 200ms;
  }
  
  .delay-300 {
    animation-delay: 300ms;
  }
  
  .delay-500 {
    animation-delay: 500ms;
  }
  
  /* Transições suaves */
  .transition-all {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .transition-fast {
    transition: all 0.15s ease-out;
  }
  
  .transition-slow {
    transition: all 0.6s ease-out;
  }
  
  /* Efeitos de hover modernos */
  .hover-lift:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }
  
  .hover-scale:hover {
    transform: scale(1.05);
  }
  
  .hover-rotate:hover {
    transform: rotate(5deg);
  }
  
  .hover-glow:hover {
    box-shadow: 0 0 20px rgba(79, 70, 229, 0.4);
  }
  
  /* Efeitos de foco melhorados */
  .focus-ring:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  }
  
  /* Gradientes animados */
  @keyframes gradient-shift {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  
  .gradient-animated {
    background: linear-gradient(-45deg, #4f46e5, #7c3aed, #06b6d4, #10b981);
    background-size: 400% 400%;
    animation: gradient-shift 15s ease infinite;
  }
  
  /* Skeleton loading modernizado */
  @keyframes skeleton-loading {
    0% {
      background-position: -200px 0;
    }
    100% {
      background-position: calc(200px + 100%) 0;
    }
  }
  
  .skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
    background-size: 400px 100%;
    animation: skeleton-loading 1.4s ease-in-out infinite;
  }
  
  .skeleton-dark {
    background: linear-gradient(90deg, #374151 25%, #4b5563 37%, #374151 63%);
    background-size: 400px 100%;
    animation: skeleton-loading 1.4s ease-in-out infinite;
  }
  
  /* Ripple effect para botões */
  .ripple {
    position: relative;
    overflow: hidden;
  }
  
  .ripple::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
  }
  
  .ripple:active::before {
    width: 300px;
    height: 300px;
  }
  
  /* Floating labels para inputs */
  .floating-label {
    position: relative;
  }
  
  .floating-label input {
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 16px;
    background: transparent;
    outline: none;
    transition: all 0.3s ease;
    width: 100%;
  }
  
  .floating-label label {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    background: white;
    padding: 0 4px;
    color: #64748b;
    font-size: 16px;
    transition: all 0.3s ease;
    pointer-events: none;
  }
  
  .floating-label input:focus,
  .floating-label input:not(:placeholder-shown) {
    border-color: #4f46e5;
  }
  
  .floating-label input:focus + label,
  .floating-label input:not(:placeholder-shown) + label {
    top: 0;
    transform: translateY(-50%);
    font-size: 12px;
    color: #4f46e5;
    font-weight: 600;
  }
  
  /* Notificações toast animadas */
  .toast-enter {
    opacity: 0;
    transform: translateX(100%);
  }
  
  .toast-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition: all 0.3s ease-out;
  }
  
  .toast-exit {
    opacity: 1;
    transform: translateX(0);
  }
  
  .toast-exit-active {
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.3s ease-in;
  }
  
  /* Smooth scroll */
  html {
    scroll-behavior: smooth;
  }
  
  /* Reduced motion para acessibilidade */
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
  
  /* Dark mode transitions */
  .theme-transition,
  .theme-transition *,
  .theme-transition *:before,
  .theme-transition *:after {
    transition: all 0.3s !important;
    transition-delay: 0 !important;
  }
  
  /* Loading spinner moderno */
  .modern-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f4f6;
    border-top: 3px solid #4f46e5;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 20px auto;
  }
  
  /* Progress bar animado */
  .progress-bar {
    width: 100%;
    height: 4px;
    background: #e5e7eb;
    border-radius: 2px;
    overflow: hidden;
    position: relative;
  }
  
  .progress-bar::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: linear-gradient(90deg, #4f46e5, #7c3aed);
    border-radius: 2px;
    animation: progress-indeterminate 2s infinite;
  }
  
  @keyframes progress-indeterminate {
    0% {
      width: 0;
      left: 0;
    }
    50% {
      width: 100%;
      left: 0;
    }
    100% {
      width: 0;
      left: 100%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/animations.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D,yBAAyB;AACzB;IACI;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,UAAU;MACV,qBAAqB;IACvB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;EACF;;EAEA,yBAAyB;EACzB;IACE;MACE,UAAU;IACZ;IACA;MACE,YAAY;IACd;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,2BAA2B;MAC3B,qDAAqD;IACvD;IACA;MACE,wBAAwB;MACxB,qDAAqD;IACvD;EACF;;EAEA,uBAAuB;EACvB;IACE;MACE,wBAAwB;IAC1B;IACA;MACE,2BAA2B;IAC7B;IACA;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE;MACE,mBAAmB;IACrB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,0CAA0C;IAC5C;IACA;MACE,2CAA2C;IAC7C;EACF;;EAEA,uCAAuC;EACvC;IACE,iCAAiC;EACnC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,iDAAiD;EACnD;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,sBAAsB;EACtB;IACE,iDAAiD;EACnD;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,8BAA8B;EAC9B;IACE,2BAA2B;IAC3B,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA,+BAA+B;EAC/B;IACE,aAAa;IACb,4CAA4C;EAC9C;;EAEA,wBAAwB;EACxB;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,6BAA6B;IAC/B;IACA;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE,uEAAuE;IACvE,0BAA0B;IAC1B,2CAA2C;EAC7C;;EAEA,iCAAiC;EACjC;IACE;MACE,6BAA6B;IAC/B;IACA;MACE,yCAAyC;IAC3C;EACF;;EAEA;IACE,yEAAyE;IACzE,2BAA2B;IAC3B,qDAAqD;EACvD;;EAEA;IACE,yEAAyE;IACzE,2BAA2B;IAC3B,qDAAqD;EACvD;;EAEA,8BAA8B;EAC9B;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,gCAAgC;IAChC,mCAAmC;EACrC;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA,gCAAgC;EAChC;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,MAAM;IACN,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA,kBAAkB;EAClB;IACE,uBAAuB;EACzB;;EAEA,uCAAuC;EACvC;IACE;MACE,qCAAqC;MACrC,uCAAuC;MACvC,sCAAsC;IACxC;EACF;;EAEA,0BAA0B;EAC1B;;;;IAIE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA,4BAA4B;EAC5B;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;EACnB;;EAEA,yBAAyB;EACzB;IACE,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,oDAAoD;IACpD,kBAAkB;IAClB,6CAA6C;EAC/C;;EAEA;IACE;MACE,QAAQ;MACR,OAAO;IACT;IACA;MACE,WAAW;MACX,OAAO;IACT;IACA;MACE,QAAQ;MACR,UAAU;IACZ;EACF","sourcesContent":["/* Arquivo: animations.css - Adicione este arquivo ao projeto */\n\n/* Animações de entrada */\n@keyframes fadeInUp {\n    from {\n      opacity: 0;\n      transform: translateY(30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @keyframes fadeInDown {\n    from {\n      opacity: 0;\n      transform: translateY(-30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @keyframes fadeInLeft {\n    from {\n      opacity: 0;\n      transform: translateX(-30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n  \n  @keyframes fadeInRight {\n    from {\n      opacity: 0;\n      transform: translateX(30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n  \n  @keyframes scaleIn {\n    from {\n      opacity: 0;\n      transform: scale(0.9);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n  \n  /* Animações de loading */\n  @keyframes pulse {\n    0%, 100% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.5;\n    }\n  }\n  \n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  @keyframes bounce {\n    0%, 100% {\n      transform: translateY(-25%);\n      animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n    }\n    50% {\n      transform: translateY(0);\n      animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n    }\n  }\n  \n  /* Animações de hover */\n  @keyframes shake {\n    0%, 100% {\n      transform: translateX(0);\n    }\n    10%, 30%, 50%, 70%, 90% {\n      transform: translateX(-2px);\n    }\n    20%, 40%, 60%, 80% {\n      transform: translateX(2px);\n    }\n  }\n  \n  @keyframes heartbeat {\n    0% {\n      transform: scale(1);\n    }\n    14% {\n      transform: scale(1.1);\n    }\n    28% {\n      transform: scale(1);\n    }\n    42% {\n      transform: scale(1.1);\n    }\n    70% {\n      transform: scale(1);\n    }\n  }\n  \n  @keyframes glow {\n    0%, 100% {\n      box-shadow: 0 0 5px rgba(79, 70, 229, 0.5);\n    }\n    50% {\n      box-shadow: 0 0 20px rgba(79, 70, 229, 0.8);\n    }\n  }\n  \n  /* Classes utilitárias para animações */\n  .animate-fade-in-up {\n    animation: fadeInUp 0.6s ease-out;\n  }\n  \n  .animate-fade-in-down {\n    animation: fadeInDown 0.6s ease-out;\n  }\n  \n  .animate-fade-in-left {\n    animation: fadeInLeft 0.6s ease-out;\n  }\n  \n  .animate-fade-in-right {\n    animation: fadeInRight 0.6s ease-out;\n  }\n  \n  .animate-scale-in {\n    animation: scaleIn 0.3s ease-out;\n  }\n  \n  .animate-pulse {\n    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  }\n  \n  .animate-spin {\n    animation: spin 1s linear infinite;\n  }\n  \n  .animate-bounce {\n    animation: bounce 1s infinite;\n  }\n  \n  .animate-shake {\n    animation: shake 0.5s ease-in-out;\n  }\n  \n  .animate-heartbeat {\n    animation: heartbeat 2s ease-in-out infinite;\n  }\n  \n  .animate-glow {\n    animation: glow 2s ease-in-out infinite alternate;\n  }\n  \n  /* Delays para animações sequenciais */\n  .delay-100 {\n    animation-delay: 100ms;\n  }\n  \n  .delay-200 {\n    animation-delay: 200ms;\n  }\n  \n  .delay-300 {\n    animation-delay: 300ms;\n  }\n  \n  .delay-500 {\n    animation-delay: 500ms;\n  }\n  \n  /* Transições suaves */\n  .transition-all {\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  \n  .transition-fast {\n    transition: all 0.15s ease-out;\n  }\n  \n  .transition-slow {\n    transition: all 0.6s ease-out;\n  }\n  \n  /* Efeitos de hover modernos */\n  .hover-lift:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  }\n  \n  .hover-scale:hover {\n    transform: scale(1.05);\n  }\n  \n  .hover-rotate:hover {\n    transform: rotate(5deg);\n  }\n  \n  .hover-glow:hover {\n    box-shadow: 0 0 20px rgba(79, 70, 229, 0.4);\n  }\n  \n  /* Efeitos de foco melhorados */\n  .focus-ring:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n  }\n  \n  /* Gradientes animados */\n  @keyframes gradient-shift {\n    0% {\n      background-position: 0% 50%;\n    }\n    50% {\n      background-position: 100% 50%;\n    }\n    100% {\n      background-position: 0% 50%;\n    }\n  }\n  \n  .gradient-animated {\n    background: linear-gradient(-45deg, #4f46e5, #7c3aed, #06b6d4, #10b981);\n    background-size: 400% 400%;\n    animation: gradient-shift 15s ease infinite;\n  }\n  \n  /* Skeleton loading modernizado */\n  @keyframes skeleton-loading {\n    0% {\n      background-position: -200px 0;\n    }\n    100% {\n      background-position: calc(200px + 100%) 0;\n    }\n  }\n  \n  .skeleton {\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);\n    background-size: 400px 100%;\n    animation: skeleton-loading 1.4s ease-in-out infinite;\n  }\n  \n  .skeleton-dark {\n    background: linear-gradient(90deg, #374151 25%, #4b5563 37%, #374151 63%);\n    background-size: 400px 100%;\n    animation: skeleton-loading 1.4s ease-in-out infinite;\n  }\n  \n  /* Ripple effect para botões */\n  .ripple {\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .ripple::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.3);\n    transform: translate(-50%, -50%);\n    transition: width 0.6s, height 0.6s;\n  }\n  \n  .ripple:active::before {\n    width: 300px;\n    height: 300px;\n  }\n  \n  /* Floating labels para inputs */\n  .floating-label {\n    position: relative;\n  }\n  \n  .floating-label input {\n    border: 2px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 12px 16px;\n    font-size: 16px;\n    background: transparent;\n    outline: none;\n    transition: all 0.3s ease;\n    width: 100%;\n  }\n  \n  .floating-label label {\n    position: absolute;\n    left: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: white;\n    padding: 0 4px;\n    color: #64748b;\n    font-size: 16px;\n    transition: all 0.3s ease;\n    pointer-events: none;\n  }\n  \n  .floating-label input:focus,\n  .floating-label input:not(:placeholder-shown) {\n    border-color: #4f46e5;\n  }\n  \n  .floating-label input:focus + label,\n  .floating-label input:not(:placeholder-shown) + label {\n    top: 0;\n    transform: translateY(-50%);\n    font-size: 12px;\n    color: #4f46e5;\n    font-weight: 600;\n  }\n  \n  /* Notificações toast animadas */\n  .toast-enter {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  \n  .toast-enter-active {\n    opacity: 1;\n    transform: translateX(0);\n    transition: all 0.3s ease-out;\n  }\n  \n  .toast-exit {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  \n  .toast-exit-active {\n    opacity: 0;\n    transform: translateX(100%);\n    transition: all 0.3s ease-in;\n  }\n  \n  /* Smooth scroll */\n  html {\n    scroll-behavior: smooth;\n  }\n  \n  /* Reduced motion para acessibilidade */\n  @media (prefers-reduced-motion: reduce) {\n    *, *::before, *::after {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n  \n  /* Dark mode transitions */\n  .theme-transition,\n  .theme-transition *,\n  .theme-transition *:before,\n  .theme-transition *:after {\n    transition: all 0.3s !important;\n    transition-delay: 0 !important;\n  }\n  \n  /* Loading spinner moderno */\n  .modern-spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid #f3f4f6;\n    border-top: 3px solid #4f46e5;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin: 20px auto;\n  }\n  \n  /* Progress bar animado */\n  .progress-bar {\n    width: 100%;\n    height: 4px;\n    background: #e5e7eb;\n    border-radius: 2px;\n    overflow: hidden;\n    position: relative;\n  }\n  \n  .progress-bar::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    background: linear-gradient(90deg, #4f46e5, #7c3aed);\n    border-radius: 2px;\n    animation: progress-indeterminate 2s infinite;\n  }\n  \n  @keyframes progress-indeterminate {\n    0% {\n      width: 0;\n      left: 0;\n    }\n    50% {\n      width: 100%;\n      left: 0;\n    }\n    100% {\n      width: 0;\n      left: 100%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
